module.exports = __webpack_public_path__ + "img/logo_row_white_th.302ab4c1.svg";